import React, { useContext } from 'react'
import {
  Grid,
  Divider,
  useMediaQuery,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { BackButton } from '../Core/Buttons/BackButton'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { ClaimContextStore } from '../../context/ClaimContext'
import { SessionContextStore } from '../../context/SessionContext'

export const ClaimNoticeInformation = () => {
  const sessionContext = useContext(SessionContextStore)
  const claimContext = useContext(ClaimContextStore)
  const isMobileByWidth = !useMediaQuery((theme) => theme.breakpoints.up('md'))
  const [confirm, setConfirm] = React.useState(false)
  const [error, setError] = React.useState('')

  const onCheckboxConfirm = () =>
    setConfirm(!confirm) ||
    (error == 'You must confirm by clicking the checkbox above' && setError(''))

  const onContinue = () => {
    if (!confirm) {
      setError('You must confirm by clicking the checkbox above')
      return
    }

    EventEmitterService.dispatch(EventKey.CLAIM_SELECT_POLICY)
  }

  return (
    <>
      <br />
      <br />
      <div className="text-title blue bold">Things to note</div>
      {!isMobileByWidth && <Divider />}
      <div className="text-body black">
        Please read the following information before submitting your claim:
      </div>
      <br />
      <ul>
        <li>
          <div className="text-body black">
            Upon submission, the SkyWatch.AI claims team will review your
            details. A representative will contact you directly for the next
            steps and for any additional information that may be required
          </div>
        </li>

        {sessionContext.user.claimCount == 0 && (
          <>
            <br />
            <li>
              <div className="text-body black">
                After your first claim, your acquired discounts will be
                discontinued for upcoming renewals
              </div>
            </li>
          </>
        )}
        {sessionContext.user.claimCount == 1 && (
          <>
            <br />
            <li>
              <div className="text-body black">
                As this is your second claim, you will no longer be eligible for
                hull coverage on future SkyWatch.AI policies
              </div>
            </li>
          </>
        )}
      </ul>
      <br />
      <div className="text-body black">
        Be sure to check your inbox for an email confirmation of your
        submission.
      </div>
      <br />
      <FormControlLabel
        label={
          'I hereby confirm that all details provided are true and legal actions may be taken should suspicion arise'
        }
        control={
          <Checkbox
            checked={confirm}
            onClick={onCheckboxConfirm}
            color="primary"
          />
        }
      />
      <br />
      {!!error && <div className="text-body red">{error}</div>}
      <FlexView className="margin-top-basic">
        <BackButton />
        <ContinueButton onClick={onContinue} />
      </FlexView>
    </>
  )
}
